<div *ngIf="loadingService.loading$ | async" class="loading-overlay">
  <div class="loading-spinner"></div>
  <p>Procesando...</p>
</div>
